import { useState } from "react";
import { toast } from "sonner";
import { CalendarArrowUp, Loader2, Trash2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errorMessage } from "@/lib/api";
import { useServices } from "@/context/ServicesContext";

export const BulkBar = ({ selected, list, onClear }) => {
  const { bump } = useServices();
  const [busy, setBusy] = useState("");
  const picked = list.filter((s) => selected.has(s.id));
  const pending = picked.filter((s) => s.status === "agendado").length;

  const run = async (action) => {
    if (action === "delete" && !window.confirm(`Excluir ${picked.length} serviço(s)? Os próximos retornos agendados que foram gerados por eles também serão apagados. Não dá para desfazer.`)) return;
    setBusy(action);
    try {
      const { data } = await api.post("/services/bulk", { ids: picked.map((s) => s.id), action });
      const skipped = picked.length - data.done;
      toast.success(action === "delete" ? `${data.done} serviço(s) excluído(s).` : `${data.done} serviço(s) passado(s) para o próximo mês.${skipped ? ` ${skipped} realizado(s) não foram movidos.` : ""}`);
      onClear();
      bump();
    } catch (err) { toast.error(errorMessage(err)); } finally { setBusy(""); }
  };

  if (!picked.length) return null;
  return (
    <div className="sticky bottom-0 z-20 -mx-6 mt-4 flex items-center gap-2 border-t border-slate-700 bg-slate-900/95 px-6 py-3 backdrop-blur-xl" data-testid="month-bulk-bar">
      <span className="mr-auto whitespace-nowrap text-sm font-semibold" data-testid="month-bulk-count">{picked.length}<span className="hidden sm:inline"> selecionado(s)</span></span>
      <Button size="sm" variant="outline" disabled={!!busy || !pending} onClick={() => run("next_month")} className="rounded-full border-sky-400/60 bg-transparent text-sky-200" data-testid="month-bulk-next">
        {busy === "next_month" ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <CalendarArrowUp className="mr-1 h-4 w-4" />} <span className="hidden sm:inline">Próximo mês</span><span className="sm:hidden">Mês +1</span>
      </Button>
      <Button size="sm" variant="outline" disabled={!!busy} onClick={() => run("delete")} className="rounded-full border-rose-400/60 bg-transparent text-rose-200" data-testid="month-bulk-delete">
        {busy === "delete" ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Trash2 className="mr-1 h-4 w-4" />} <span className="hidden sm:inline">Excluir</span>
      </Button>
      <Button size="sm" variant="ghost" onClick={onClear} className="rounded-full" data-testid="month-bulk-clear"><X className="h-4 w-4 sm:mr-1" /> <span className="hidden sm:inline">Limpar</span></Button>
    </div>
  );
};
